
<div *ngIf="isValidUser">
 
  <div style="padding-top: 0px; margin-left: 15px; margin-right: 15px"
    *ngIf="loggedinUserType != 'Contractor'">

    <div class="col-md-8 welcome-hometag" >

      <h1>Welcome</h1>
      <h2>
        MFANO tracks QHSSE related activities with traceability and visibility
        to achieve organizational goals
      </h2>

    </div>
    <div class="col-md-4 welcome-hometag" style="text-align: right;"  >
      <img src="{{ HomePageImagePath }}" class="target-zeroimg" />

    </div>
    <div class="clearfix"></div>
    
        <div class="col-md-8">
        <div class="user-detail"> <h2>User Details</h2>
        <div class=" row pending-section" style="padding: 0px 15px; " >
        <div class="row" >

          <div class="col-sm-2 " style="margin-bottom: 20px;">
            <div class="" >
           
              <h4 style="color: #006a6c;top: 11px;position: relative;font-size: 14px; padding-top: 0px; padding-left: 5px; ">Date Range:</h4>
           
            </div>
          </div>

          <div class="col-sm-3  " style="margin-top: 15px;">
            <p-calendar
                            [showIcon]="true"                       
                            [showTime]="false"
                            placeholder="From"
                            dateFormat="dd/mm/yy"
                            [(ngModel)]="FromDateForUser"
                            class="custom-datepicker "
                            readonlyInput="true"
                            required
                            #timeOfUse="ngModel"
                            monthNavigator="true"
                            yearNavigator="true"
                            yearRange="1950:2100"
                            showButtonBar="true"
                          >
            </p-calendar></div>
            <div class="col-sm-3 "  style="margin-top: 15px;">
            <p-calendar
                            [showIcon]="true"                       
                            [showTime]="false"
                            placeholder="To"
                            dateFormat="dd/mm/yy"
                            [(ngModel)]="ToDateForUser"
                            class="custom-datepicker "
                            readonlyInput="true"
                            required
                            #timeOfUse="ngModel"
                            monthNavigator="true"
                            yearNavigator="true"
                            yearRange="1950:2100"
                            showButtonBar="true"
                          >
            </p-calendar>
            </div>
            <div class="col-sm-4  "  style="margin-top: 12px;     padding-left: 20px; margin-bottom: 10px;">
            <a
            (click)="GetDashboardCount(1)"
            role="button"
            class="btn btn-success  button-submit"
          >
            Refresh
          </a></div>

        </div>
        <div class="clearfix"></div>
    <div class="row">  
    <div class="col-sm-4 ">
      <div class="tile-stats tile-white" >
        <div class="num" >
          <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
          (click)="GetDashboardSelectedDetails('User','Obs')" data-target="#AT"> {{ ObservationCountForUser }} </a> 
        </div>
        <h3>No of Observation</h3>      
      </div>
    </div>
    <div class="col-sm-4 ">
      <div class="tile-stats tile-white" >
        <div class="num" >
          <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
          (click)="GetDashboardSelectedDetails('User','Inc')" data-target="#AT"> {{ IncidentCountForUser }} </a> 
        </div>
        <h3 >No of Incident</h3>  
      </div>
    </div>
    <div class="col-sm-4 ">
      <div class="tile-stats tile-white">
        <div class="num" >
          <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
          (click)="GetDashboardSelectedDetails('User','Ins')" data-target="#AT"> {{ InspectionCountForUser }} </a> 
        </div>
        <h3 >No of Inspection</h3>      
      </div>
    </div>
   </div>
   <div class="clearfix"></div>
    <div class="row scoend-row">
    <div class="col-sm-4 ">
      <div class="tile-stats tile-white" >
        <div class="num"  >
          <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
          (click)="GetDashboardSelectedDetails('User','Permit')" data-target="#AT"> {{ PermitCountForUser }} </a> 
          </div>
        <h3 >No of Permit</h3>     
      </div>
    </div>
    <div class="col-sm-4 ">
      <div class="tile-stats tile-white" >
        <div class="num" >
          <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
          (click)="GetDashboardSelectedDetails('User','Risk')" data-target="#AT"> {{ RiskCountForUser }} </a> 
        </div>
        <h3 >Raised Risk</h3>
      </div>
    </div>
    <div class="col-sm-4 scoend-row ">
      <div class="tile-stats tile-white"  >
        <div class="num" >
          <a data-toggle="modal" pTooltip="Get Details" tooltipPosition="top"
          (click)="GetDashboardSelectedDetails('User','Action')" data-target="#AT"> {{ ActionCountForUser }} </a> 
        </div>
        <h3>No of Action</h3>
      
      </div>
    </div>
  </div> 
</div> </div></div>
<div class="col-md-4 user-detail">
  <h2>MFANO User Details</h2>
  <div class=" row pending-section" style="padding-bottom: 5px;">
    <div class="row">
    <div class="col-sm-12" style="margin-top: 5px;"> 
          <div class="col-sm-2 ">
          </div>
          <div class="col-sm-8 ">
            <div class="tile-stats tile-white" style="
            padding: 5px 15px;
            margin-bottom: 3px; "
              >
              <div class="num">
                {{ LoggedInUsers }}
                </div>
              <h3>Logged In Users</h3>          
            </div>
          </div>
  
          <div class="col-sm-2 ">
    
          </div>
        </div>
  
        <div class="col-sm-12" > 
          <div class="col-sm-2 "> 
          </div>
  
          <div class="col-sm-8 ">
            <div class="tile-stats tile-white" style="
            padding: 5px 15px;
            margin-bottom: 3px; " >
              <div class="num" >
                {{ Employees }}
                </div>
              <h3 >Registered Employees</h3>         
            </div>
          </div>
  
          <div class="col-sm-2 ">
          </div>
        </div>
  
        <div class="col-sm-12" > 
          <div class="col-sm-2 ">
          </div>
          <div class="col-sm-8 ">
            <div class="tile-stats tile-white" style="
            padding: 5px 15px;
            margin-bottom: 3px; "  >
              <div class="num" >
                {{ Contractors }}
                </div>
              <h3>Registered Contractors</h3>       
            </div>
          </div>
  
          <div class="col-sm-2 ">
          </div>
  
        </div>
        </div>
      </div>
  </div>
  <div class="clearfix"></div>

  <div class="col-md-8">
    <div class="user-detail"> <h2>Data Overview</h2>
    <div class=" row pending-section" style="padding: 0px 15px; " >
    <div class="row" >
      <div class="col-sm-2 " style="margin-bottom: 20px;">
        <div class="" >
       
          <h4 style="color: #006a6c;top: 11px;position: relative;font-size: 14px; padding-top: 0px; padding-left: 5px; ">Date Range:</h4>
       
        </div>
      </div>

      <div class="col-sm-3  " style="margin-top: 15px;">
        <p-calendar
                        [showIcon]="true"                       
                        [showTime]="false"
                        placeholder="From"
                        dateFormat="dd/mm/yy"
                        [(ngModel)]="FromDate"
                        class="custom-datepicker "
                        readonlyInput="true"
                        required
                        #timeOfUse="ngModel"
                        monthNavigator="true"
                        yearNavigator="true"
                        yearRange="1950:2100"
                        showButtonBar="true"
                      >
        </p-calendar></div>
        <div class="col-sm-3 "  style="margin-top: 15px;">
        <p-calendar
                        [showIcon]="true"                       
                        [showTime]="false"
                        placeholder="To"
                        dateFormat="dd/mm/yy"
                        [(ngModel)]="ToDate"
                        class="custom-datepicker "
                        readonlyInput="true"
                        required
                        #timeOfUse="ngModel"
                        monthNavigator="true"
                        yearNavigator="true"
                        yearRange="1950:2100"
                        showButtonBar="true"
                      >
        </p-calendar>
        </div>
        <div class="col-sm-4  "  style="margin-top: 12px;     padding-left: 20px; margin-bottom: 10px;">
        <a
        (click)="GetDashboardCount(2)"
        role="button"
        class="btn btn-success  button-submit"
      >
        Refresh
      </a></div>

    </div>
    <div class="clearfix"></div>
<div class="row">  
<div class="col-sm-4 ">
  <div class="tile-stats tile-white" >
    <div class="num" >
      <a pTooltip="Get Details" [routerLink]="['/observation/observation-card-overview',{ D: 1 }]"> {{ ObservationCount }} </a>
    </div>
    <h3>No of Observation</h3> 
  </div>
</div>
<div class="col-sm-4 ">
  <div class="tile-stats tile-white" >
    <div class="num" >
      <a pTooltip="Get Details" [routerLink]="['/incident/incident-overview',{ D: 1 }]"> {{ IncidentCount }} </a>
    </div>
    <h3 >No of Incident</h3>
  </div>
</div>
<div class="col-sm-4 ">
  <div class="tile-stats tile-white">
    <div class="num" >
       <a pTooltip="Get Details" [routerLink]="['/inspection/inspections-overview',{ D: 1 }]"> {{ InspectionCount }} </a>
    </div>
    <h3 >No of Inspection</h3>   
  </div>
</div>
</div>
<div class="clearfix"></div>
<div class="row">
<div class="col-sm-4 ">
  <div class="tile-stats tile-white" >
    <div class="num"  >
       <a pTooltip="Get Details" [routerLink]="['/pob/pob-list-overview',{ D: 1 }]"> {{ POBCount }} </a>
      </div>
    <h3 >Person On Board</h3> 
  </div>
</div>
<div class="col-sm-4 ">
  <div class="tile-stats tile-white" >
    <div class="num" >
       <a pTooltip="Get Details" [routerLink]="['/risk/risk-overview',{ D: 1 }]"> {{ RiskCount }} </a>
    </div>
    <h3 >Raised Risk</h3>
  </div>
</div>
<div class="col-sm-4 " style="margin-bottom: 25px;">
  <div class="tile-stats tile-white"  >
    <div class="num" >
       <a pTooltip="Get Details" [routerLink]="['/actiontracker/actions-overview',{ D: 1 }]"> {{ ActionCount }} </a>
    </div>
    <h3>No of Action</h3>  
  </div>
</div>
</div> 
</div> </div></div>
<div class="col-md-4">
  <div class="pending-approval">
    <h2> Pending for Approval</h2>
    <div class="mainhome-pg" >
      <div class="row pending-section" >    
          <div class="col-sm-6" style="margin: 35px 0px 0px 0px;">
            <div class="tile-stats tile-white" >
              <div class="num" >
                {{ PTWPending }}
                </div>
              <h3>Permit</h3>       
            </div>
          </div>
          <div class="col-sm-6 margin-top" style="margin: 35px 0px 0px 0px;">
            <div class="tile-stats tile-white" >
              <div class="num" >
                {{TNCPending}}
              </div>
              <h3>Training</h3>
            </div>
          </div>
          <div class="col-sm-6  " style="margin: 15px 0px;">
            <div class="tile-stats tile-white" >
              <div class="num" >
                {{RiskPending}}
              </div>
              <h3>Risk</h3>       
            </div>
          </div>
          <div class="col-sm-6 scoend-row " style="margin: 15px 0px 29px 0px;">
            <div class="tile-stats tile-white" >
              <div class="num" >
                {{ActionPending}}
              </div>
              <h3>Action</h3>         
            </div>
          </div>
        </div> 
        
      </div></div>
  
  </div>

<div class="clearfix"></div>

  </div>
  <div *ngIf="loggedinUserType == 'Contractor'">
    <br />
    <br />
    <br />
    <br />
    <br />
  <div class="row">
    <div class="col-sm-12">
      <div
        class=""
        style="text-align: center; vertical-align: central;margin-bottom: 18%;"
      >
        <br />
        <br />
        <h1>Welcome</h1>
        <h2>
          MFANO tracks QHSSE related activities with traceability and visibility
          to achieve organizational goals
        </h2>
        <br />
        <img src="{{ HomePageImagePath }}" style="width:20%;" />
      </div>
    </div>
  </div>
</div>
</div>
<!-- <div class="page-content-wrapper-for-tile" *ngIf="isValidUser">
    <div class="col-lg-12 col-md-12 col-sm-12 mobile-view">
      <div class="inner-wrapper">
        <div class="sub-wrapper">
          <h3 class="page-title">ARA QHSSE App Menu</h3>
          <div class="section-wrapper-for-tile">
            <div class="tiles-wrapper">
              <div class="tile front-tile">
                <p *ngIf="permissions.OBS_Add || permissions.OBS_Add_Unit || permissions.OBS_Admin || permissions.OBS_Admin_Unit"
                  [routerLink]="['/observation/make-observation', 'new']">
                  <a [routerLink]="['/observation/make-observation', 'new']">safety
                    observation</a>
                </p>
                <p *ngIf="!permissions.OBS_Add && !permissions.OBS_Add_Unit  && !permissions.OBS_Admin && !permissions.OBS_Admin_Unit"
                  [routerLink]="['/observation/observation-card-overview']">
                  <a [routerLink]="['/observation/observation-card-overview']">safety
                    observation</a>
                </p>
              </div>
            </div>
            <div class="tiles-wrapper">
              <div class="tile front-tile">
                <p [routerLink]="isOnline ? ['/risk/raise-risk', 'new']:null">
                  <a [ngClass]="isOnline ? 'cursor-pointer' : 'disabled'" *ngIf="permissions.RSK_Add || permissions.RSK_Add_Unit || permissions.RSK_Admin || permissions.RSK_Admin_Unit"
                    [routerLink]="isOnline ? ['/risk/raise-risk', 'new']:null">risk
                    register</a>
                </p>
                <p [routerLink]="isOnline ? ['/risk/risk-overview']:null">
                  <a [ngClass]="isOnline ? 'cursor-pointer' : 'disabled'" 
                  *ngIf="!permissions.RSK_Add && !permissions.RSK_Add_Unit && !permissions.RSK_Admin && !permissions.RSK_Admin_Unit"
                    [routerLink]="isOnline ? ['/risk/risk-overview']:null">risk
                    register</a>
                </p>
              </div>
            </div>
            <div class="tiles-wrapper">
              <div class="tile front-tile">
                <p
                  [routerLink]="isOnline && (permissions.INC_Add || permissions.INC_Add_Unit || permissions.INC_Admin || permissions.INC_Admin_Unit) ? ['/incident/report-incident', 'new']:['/incident/incident-overview']">
                  <a [ngClass]="isOnline ? 'cursor-pointer' : 'disabled'"
                    [routerLink]="isOnline && (permissions.INC_Add || permissions.INC_Add_Unit || permissions.INC_Admin || permissions.INC_Admin_Unit) ? ['/incident/report-incident', 'new']:['/incident/incident-overview']">incident
                    management</a>
                </p>
              </div>
            </div>
            <div class="tiles-wrapper">
              <div class="tile front-tile">
                <p
                  [routerLink]="isOnline && (permissions.ACT_Add || permissions.ACT_Add_Unit || permissions.ACT_Admin || permissions.ACT_Admin_Unit) ? ['/actiontracker/source-action']: ['/actiontracker/actions-overview']">
                  <a [ngClass]="isOnline ? 'cursor-pointer' : 'disabled'"
                    [routerLink]="isOnline  && (permissions.ACT_Add || permissions.ACT_Add_Unit || permissions.ACT_Admin || permissions.ACT_Admin_Unit)? ['/actiontracker/source-action']: ['/actiontracker/actions-overview']">action
                    tracker</a>
                </p>
              </div>
  
            </div>
            <div class="tiles-wrapper">
              <div class="tile front-tile">
                <p
                  [routerLink]="(permissions.POB_Contractor_Add || permissions.POB_Contractor_Add_Unit || permissions.POB_Staff_Add || permissions.POB_Staff_Add_Unit || permissions.POB_Admin || permissions.POB_Admin_Unit) ? ['/pob/raise-passrequest/new']: ['/pob/pob-list-overview']">
                  <a
                    [routerLink]="(permissions.POB_Contractor_Add || permissions.POB_Contractor_Add_Unit || permissions.POB_Staff_Add || permissions.POB_Staff_Add_Unit || permissions.POB_Admin || permissions.POB_Admin_Unit) ? ['/pob/raise-passrequest/new']: ['/pob/pob-list-overview']">Person
                    On Board</a>
                </p>
              </div>
            </div>
            <div class="tiles-wrapper">
              <div class="tile front-tile">
                <p [ngClass]="isOnline ? 'cursor-pointer' : 'disabled'"
                  [routerLink]="isOnline && (permissions.INSP_Add || permissions.INSP_Add_Unit || permissions.INSP_Admin || permissions.INSP_Admin_Unit) ? ['/inspection/add-inspection/new']: ['/inspection/inspections-overview']">
                  <a [ngClass]="isOnline ? 'cursor-pointer' : 'disabled'"
                    [routerLink]="isOnline && (permissions.INSP_Add || permissions.INSP_Add_Unit || permissions.INSP_Admin || permissions.INSP_Admin_Unit) ? ['/inspection/add-inspection/new']: ['/inspection/inspections-overview']">Inspection
                    and
                    Audit</a>
                </p>
              </div>
            </div>
            <div class="tiles-wrapper">
              <div class="tile front-tile">
                <p [ngClass]="isOnline ? 'cursor-pointer' : 'disabled'"
                  [routerLink]="isOnline && (permissions.TSK_Add || permissions.TSK_Add_Unit || permissions.TSK_Admin || permissions.TSK_Admin_Unit) ? ['/task/task'] :  ['/task/task-list']">
                  <a [ngClass]="isOnline ? 'cursor-pointer' : 'disabled'"
                    [routerLink]="isOnline && (permissions.TSK_Add || permissions.TSK_Add_Unit || permissions.TSK_Admin || permissions.TSK_Admin_Unit) ? ['/task/task']: ['/task/task-list']">Task
                    Monitor</a>
                </p>
              </div>
            </div>
            <div class="tiles-wrapper">
              <div class="tile front-tile">
                <p [ngClass]="isOnline ? 'cursor-pointer' : 'disabled'"
                  [routerLink]="isOnline && (permissions.PTW_Add || permissions.PTW_Add_Unit || permissions.PTW_Admin || permissions.PTW_Admin_Unit) ? ['/ptw/raise-permit']:['/ptw/permit-overview']">
                  <a [ngClass]="isOnline ? 'cursor-pointer' : 'disabled'"
                    [routerLink]="isOnline && (permissions.PTW_Add || permissions.PTW_Add_Unit || permissions.PTW_Admin || permissions.PTW_Admin_Unit) ? ['/ptw/raise-permit']:['/ptw/permit-overview']">Permit
                    To Work</a>
                </p>
              </div>
            </div>
            <div class="tiles-wrapper">
              <div class="tile front-tile">
                <p [ngClass]="isOnline ? 'cursor-pointer' : 'disabled'"
                  [routerLink]="isOnline && (permissions.TNC_Add || permissions.TNC_Add_Unit || permissions.TNC_Admin || permissions.TNC_Admin_Unit) ? ['/tnc/assign-training']: ['/tnc/tnc-overview']">
                  <a [ngClass]="isOnline ? 'cursor-pointer' : 'disabled'"
                    [routerLink]="isOnline && (permissions.TNC_Add || permissions.TNC_Add_Unit || permissions.TNC_Admin || permissions.TNC_Admin_Unit) ? ['/tnc/assign-training']: ['/tnc/tnc-overview']">Training
                    and Certification</a>
                </p>
              </div>
            </div>
            <div class="tiles-wrapper">
              <div class="tile front-tile">
                <p [ngClass]="isOnline ? 'cursor-pointer' : 'disabled'"
                  [routerLink]="isOnline ? ['/dl/document-library']: ['/dl/document-library']">
                  <a [ngClass]="isOnline ? 'cursor-pointer' : 'disabled'"
                    [routerLink]="isOnline ? ['/dl/document-library']: ['/dl/document-library']">
                    Document Library</a>
                </p>
              </div>
            </div>
            <div class="tiles-wrapper" [ngStyle]="{'grid-column': !permissions.APP_Admin ?'1 / span 2':null}">
              <div class="tile front-tile">
                <p [ngClass]="isOnline ? 'cursor-pointer' : 'disabled'"
                  [routerLink]="isOnline && (permissions.PD_Add || permissions.PD_Add_Unit || permissions.PD_Admin || permissions.PD_Admin_Unit) ? ['/pd/dashboard']: ['/pd/dashboard']">
                  <a [ngClass]="isOnline ? 'cursor-pointer' : 'disabled'"
                    [routerLink]="isOnline && (permissions.PD_Add || permissions.PD_Add_Unit || permissions.PD_Admin || permissions.PD_Admin_Unit) ? ['/pd/dashboard']: ['/pd/dashboard']">
                    Performance Dashboard</a>
                </p>
              </div>
            </div>
            <div *ngIf="permissions.HSE_Admin || permissions.APP_Admin || permissions.SUPER_Admin" class="tiles-wrapper">
              <div class="tile front-tile">
                <p [routerLink]="isOnline ? ['/masterscreen/welcome']:null">
                  <a [ngClass]="isOnline ? 'cursor-pointer' : 'disabled'"
                    [routerLink]="isOnline ? ['/masterscreen/welcome']:null">admin</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div> -->

<div class="page-content-wrapper-for-tile" align="center" *ngIf="!isValidUser">
  <span class="home-error-wrapper">
    <h3 class="home-error">
      <span class="home-error-msg"
        >You do not have permission to view this application. Please contact
        administrator.</span
      >
    </h3>
  </span>
</div>

<div class="modal fade PDModal" data-backdrop="static" style="opacity:1 !important;" id="AT" role="dialog">
  <div class="modal-dialog custom-modal">

    <div class="modal-content">
      <div class="modal-header">
        
          <button type="button" style="color:black;" class="close button-cancel" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <ol id="liPDheight">
          <ng-container *ngFor="let item of SelectedData; let i=index">
            <li><a (click)="Redirect(item.Value,item.Id,item.Module)">{{item.Text }}</a></li>
         </ng-container>   
        </ol>
        <span *ngIf="SelectedData?.length < 1" style="color:red;">No Records Found..</span>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</div>